import { Link } from "react-router-dom";
import { AuthLayout } from "@/components/Layout";
import { AuthCard } from "@/components/Card";
import { Logo } from "@/components/Logo";

export default function NotFound() {
  return (
    <AuthLayout>
      <AuthCard>
        <div className="mb-6 flex justify-center"><Logo size="lg" href="https://fortehealth.co" /></div>
        <h1 className="font-serif text-[25px] font-normal text-fh-ink text-center mb-1.5">
          Page not found
        </h1>
        <p className="text-[14px] text-fh-gray text-center mb-6">
          That page doesn't exist.
        </p>
        <Link
          to="/"
          className="block text-center text-[13px] font-semibold text-fh-green hover:text-fh-green-dark"
        >
          Go home
        </Link>
      </AuthCard>
    </AuthLayout>
  );
}
